export interface ValidateTextConfig {
  textarea: HTMLTextAreaElement;
  button: HTMLElement;
  mentionUsername?: string;
  minLength?: number;
  componentName?: string;
}

// Helper function to check if timer is still running
const isTimerRunning = (componentName: string = 'cncForum'): boolean => {
  const keyStart = `${componentName}StartTime`;
  const keyEnd = `${componentName}EndTime`;
  const startTime = localStorage.getItem(keyStart);
  const endTime = localStorage.getItem(keyEnd);

  if (!startTime || !endTime) {
    return false;
  }

  // Zjistí, zda je aktálním čas před vypršením
  const now = Date.now();
  const timerEndTime = Number(endTime);

  return now < timerEndTime;
};

export const updateButtonState = ({
  textarea,
  button,
  mentionUsername,
  minLength = 5,
  componentName = 'cncForum',
}: ValidateTextConfig): void => {
  let hasValidContent = false;
  let contentToCheck = textarea.value;

  // Check if timer is running
  const timerRunning = isTimerRunning(componentName);

  if (mentionUsername) {
    const mentionText = `@${mentionUsername} `;
    contentToCheck = contentToCheck.replace(mentionText, '');
  }

  hasValidContent = contentToCheck.trim().length >= minLength;

  if (hasValidContent && !timerRunning) {
    // Only enable button if content is valid AND timer is not running
    button.removeAttribute('disabled');
  } else {
    // Disable button if content is invalid OR timer is running
    button.setAttribute('disabled', 'disabled');
  }
};

export default {
  updateButtonState,
};
